<template>
    <div>
        <div
            id="connect-modal"
            class="modal absolute-modal"
            aria-labelledby="connect-modal"
            role="dialog"
            aria-modal="true"
            v-if="showAddCardModal"
        >
            <div
                class="modal-overlay"
                aria-hidden="true"
                :class="isMobileFullscreen ? 'hidden' : ''"
            ></div>
            <div
                class="inner rounded-lg bg-white dark:bg-slate-800 shadow dark:shadow-slate-900/50 border border-slate-200 relative flex flex-col max-h-[90vh] overflow-hidden"
                :class="[
                    isMobileFullscreen
                        ? 'absolute inset-0 rounded-none border-0 shadow-none'
                        : '',
                    shouldShowConnectWidget && connectStep === 3
                        ? 'h-[90vh]'
                        : '',
                ]"
                :style="
                    isMobileFullscreen
                        ? mobileInnerStyle
                        : { '-webkit-transform': 'translate3d(0, 0, 0)' }
                "
            >
                <!-- CONNECT STEPS -->
                <div
                    id="connect-steps-section"
                    class="connect-steps flex flex-col min-h-0 flex-1 h-full"
                    :class="isMobileFullscreen ? 'overflow-y-auto' : ''"
                >
                    <!-- STEP 1: Method Choice -->
                    <ConnectMethodChoice
                        :connectStep="connectStep"
                        :users="chooseUsers"
                        :accountUserForCard="accountUserForCard"
                        :howToAddCard="howToAddCard"
                        :errors="stepErrors"
                        :isStep1Mobile="isStep1Mobile"
                        :showSecurityInfo="showSecurityInfo"
                        :selectedUserName="selectedUserName"
                        :showUserDropdown="showUserDropdown"
                        :userDropdownStyles="userDropdownStyles"
                        @close="close"
                        @gotoStep="gotoStep"
                        @update:howToAddCard="howToAddCard = $event"
                        @update:showSecurityInfo="showSecurityInfo = $event"
                        @toggleUserDropdown="toggleUserDropdown"
                        @selectUser="selectUser"
                    />

                    <!-- STEP 2 (dead code, kept for now) -->
                    <div
                        id="connect-step-2"
                        class="connect-step flex flex-col flex-1 min-h-0 h-full"
                        v-show="connectStep === 2"
                    >
                        <!-- Main Container -->
                        <div
                            class="flex w-full p-6 flex-col items-stretch gap-8 flex-1 min-h-0 h-full"
                            :class="[
                                isStep2Mobile ? 'pb-24' : 'rounded-lg bg-white dark:bg-slate-800',
                            ]"
                        >
                            <!-- Header Container -->
                            <div
                                class="flex items-start justify-between self-stretch"
                            >
                                <div
                                    class="flex flex-col justify-center items-start gap-1 flex-1"
                                >
                                    <h2
                                        class="flex-1 text-slate-800 dark:text-slate-100 text-xl font-medium leading-7"
                                    >
                                        Add card
                                    </h2>
                                    <p
                                        class="text-slate-500 dark:text-slate-400 text-sm font-normal leading-5"
                                    >
                                        Select add method
                                    </p>
                                </div>
                                <a
                                    href="#"
                                    class="btn-icon btn-transparent w-10"
                                    role="button"
                                    @click.prevent="close"
                                >
                                    <Icon icon="close" />
                                </a>
                            </div>

                            <!-- Method Container -->
                            <div
                                class="flex flex-col items-start gap-2 self-stretch"
                            >
                                <label
                                    class="text-slate-600 dark:text-slate-300 text-sm font-medium leading-5"
                                >
                                    Method
                                </label>

                                <div
                                    class="flex flex-col justify-center items-start gap-2 self-stretch"
                                >
                                    <!-- Connect via Bank Option -->
                                    <label
                                        class="flex p-3 items-center self-stretch rounded-lg cursor-pointer transition-all duration-200 relative"
                                        :class="
                                            howToAddCard === 'connect_to_bank'
                                                ? 'border-2 border-[#FD421D]'
                                                : 'border border-slate-300 dark:border-slate-700'
                                        "
                                    >
                                        <input
                                            type="radio"
                                            class="sr-only"
                                            value="connect_to_bank"
                                            v-model="howToAddCard"
                                        />
                                        <div class="absolute top-3 right-3">
                                            <div
                                                :class="[
                                                    'w-5 h-5 rounded-full border-2 flex items-center justify-center',
                                                    howToAddCard === 'connect_to_bank'
                                                        ? 'border-[#FD421D] bg-[#FD421D]'
                                                        : 'border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800',
                                                ]"
                                            >
                                                <div
                                                    v-if="howToAddCard === 'connect_to_bank'"
                                                    class="w-2 h-2 bg-white dark:bg-slate-800 rounded-full"
                                                ></div>
                                            </div>
                                        </div>
                                        <div class="flex flex-col items-start gap-2 flex-1">
                                            <div class="flex w-5 h-5 justify-start items-center">
                                                <Icon icon="bank-financial" class="w-5 h-5 text-slate-600 dark:text-slate-300" />
                                            </div>
                                            <h3 class="text-slate-800 dark:text-slate-100 text-sm font-medium leading-5">Connect account via bank</h3>
                                            <div class="flex flex-col items-start gap-1 self-stretch">
                                                <div class="text-slate-500 dark:text-slate-400 text-sm font-normal leading-5 flex items-center">
                                                    <span class="w-1 h-1 bg-slate-400 rounded-full mr-2 flex-shrink-0"></span>
                                                    Instant automatic updates
                                                </div>
                                                <div class="text-slate-500 dark:text-slate-400 text-sm font-normal leading-5 flex items-center">
                                                    <span class="w-1 h-1 bg-slate-400 rounded-full mr-2 flex-shrink-0"></span>
                                                    Adds all bank cards and bonus programs
                                                </div>
                                                <div class="text-slate-500 dark:text-slate-400 text-sm font-normal leading-5 flex items-center">
                                                    <span class="w-1 h-1 bg-slate-400 rounded-full mr-2 flex-shrink-0"></span>
                                                    Free and secure
                                                </div>
                                            </div>
                                        </div>
                                    </label>

                                    <!-- Add Card Manually Option -->
                                    <label
                                        class="flex p-3 items-center self-stretch rounded-lg cursor-pointer transition-all duration-200 relative"
                                        :class="
                                            howToAddCard === 'add_card_manually'
                                                ? 'border-2 border-[#FD421D]'
                                                : 'border border-slate-300 dark:border-slate-700'
                                        "
                                    >
                                        <input
                                            type="radio"
                                            class="sr-only"
                                            value="add_card_manually"
                                            v-model="howToAddCard"
                                        />
                                        <div class="absolute top-3 right-3">
                                            <div
                                                :class="[
                                                    'w-5 h-5 rounded-full border-2 flex items-center justify-center',
                                                    howToAddCard === 'add_card_manually'
                                                        ? 'border-[#FD421D] bg-[#FD421D]'
                                                        : 'border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800',
                                                ]"
                                            >
                                                <div
                                                    v-if="howToAddCard === 'add_card_manually'"
                                                    class="w-2 h-2 bg-white dark:bg-slate-800 rounded-full"
                                                ></div>
                                            </div>
                                        </div>
                                        <div class="flex flex-col items-start gap-2 flex-1">
                                            <div class="flex w-5 h-5 justify-start items-center">
                                                <Icon icon="edit" class="w-5 h-5 text-slate-600 dark:text-slate-300" />
                                            </div>
                                            <h3 class="text-slate-800 dark:text-slate-100 text-sm font-medium leading-5">Add card manually</h3>
                                            <div class="flex flex-col items-start gap-1 self-stretch">
                                                <div class="text-slate-500 dark:text-slate-400 text-sm font-normal leading-5 flex items-center">
                                                    <span class="w-1 h-1 bg-slate-400 rounded-full mr-2 flex-shrink-0"></span>
                                                    Add individual cards by entering details manually
                                                </div>
                                                <div class="text-slate-500 dark:text-slate-400 text-sm font-normal leading-5 flex items-center">
                                                    <span class="w-1 h-1 bg-slate-400 rounded-full mr-2 flex-shrink-0"></span>
                                                    No automatic updates, edit when needed
                                                </div>
                                                <div class="text-slate-500 dark:text-slate-400 text-sm font-normal leading-5 flex items-center">
                                                    <span class="w-1 h-1 bg-slate-400 rounded-full mr-2 flex-shrink-0"></span>
                                                    Suitable if your bank isn't supported
                                                </div>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>

                            <!-- Footer Container -->
                            <div
                                class="flex flex-row items-center p-6 bg-white dark:bg-slate-800 mt-auto w-full"
                            >
                                <div
                                    class="flex items-center gap-2 rounded cursor-pointer select-none"
                                    @click="showSecurityInfo = true"
                                >
                                    <Icon icon="security" class="w-5 h-5 flex-shrink-0 text-slate-600 dark:text-slate-300" />
                                    <span class="text-slate-800 dark:text-slate-100 text-sm font-medium leading-5">
                                        How we keep your data safe
                                    </span>
                                </div>
                                <div
                                    class="ml-auto flex items-center gap-2"
                                    :class="isStep2Mobile ? 'hidden' : ''"
                                >
                                    <button
                                        type="button"
                                        @click.prevent="close"
                                        class="flex py-2.5 px-4 items-start gap-2 rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] text-slate-800 dark:text-slate-100 text-sm font-medium leading-5 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
                                        id="hs-wallet-connect-cancel"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        @click.prevent="gotoStep(3)"
                                        class="flex py-2.5 px-4 justify-center items-center gap-2 rounded bg-slate-800 dark:bg-slate-600 shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] text-white text-sm font-medium leading-5 hover:bg-slate-700 dark:hover:bg-slate-500 transition-colors"
                                        id="hs-wallet-connect-next"
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>

                            <div class="w-full" v-show="stepErrors.length > 0">
                                <Errors :errors="stepErrors" />
                            </div>
                        </div>
                        <!-- Mobile bottom bar: full-width Next (Step 2) -->
                        <div
                            v-if="isStep2Mobile"
                            class="fixed bottom-0 left-0 right-0 bg-white dark:bg-slate-800 px-4 pt-3 pb-[max(12px,env(safe-area-inset-bottom))]"
                        >
                            <button
                                type="button"
                                @click.prevent="gotoStep(3)"
                                class="w-full py-3 rounded-md bg-slate-800 dark:bg-slate-600 text-white text-sm font-medium leading-5 hover:bg-slate-700 dark:hover:bg-slate-500 active:bg-slate-700"
                                id="hs-wallet-connect-next-mobile-step2"
                            >
                                Next
                            </button>
                        </div>
                    </div>

                    <!-- STEP 3 -->
                    <div
                        id="connect-step-3"
                        class="connect-step flex flex-col flex-1 min-h-0 h-full"
                        v-show="connectStep === 3"
                    >
                        <!-- CONNECT TO BANK -->
                        <div
                            class="w-full h-full flex flex-col min-h-0"
                            v-if="howToAddCard === 'connect_to_bank'"
                        >
                            <ConnectBankSelector
                                :visible="showInstitutionsDropdown"
                                :banks="filteredBanksList"
                                :activeBank="activeBank"
                                :bankSearchQuery="bankSearchQuery"
                                :errors="stepErrors"
                                :subtitle="chooseUsers.length > 1 && selectedUserName ? selectedUserName : ''"
                                @selectBank="handleSelectBank"
                                @back="handleBack"
                                @next="showBankLogin"
                                @close="close"
                                @update:bankSearchQuery="bankSearchQuery = $event"
                            />

                            <ConnectMxWidget
                                ref="mxWidgetComponent"
                                :connectStep="connectStep"
                                :completedConnect="completedConnect"
                                :finshedSyncAccount="finshedSyncAccount"
                                :showAccountSyncDelayMessage="showAccountSyncDelayMessage"
                                :shouldShowConnectWidget="shouldShowConnectWidget"
                                :loadingConnectWidget="loadingConnectWidget"
                                :chosenBank="chosenBank"
                                @close="close"
                                @finishAddingCard="finishAddingCard"
                            />
                        </div>
                        <!-- // END CONNECT TO BANK -->
                        <!-- MANUALLY ADD CARD -->
                        <div
                            id="manual-card-section"
                            class="w-full h-full"
                            v-if="howToAddCard === 'add_card_manually'"
                        >
                            <ManualCardEntry
                                :accountUserForCard="accountUserForCard"
                                :wallet="wallet"
                                :cards="bankCards"
                                :banks="banks"
                                @gotoStep="gotoStep"
                                @finished="finishAddingCard"
                                @setProgress="setProgress"
                                @showAddBusinessModal="showAddBusinessModal"
                                @close="emit('close')"
                            />
                        </div>
                        <!-- // END MANUALLY ADD CARD -->
                    </div>
                </div>
                <!-- // END CONNECT STEPS -->
            </div>
        </div>

        <SecurityInfoModal
            :open="showSecurityInfo"
            @close="showSecurityInfo = false"
        />
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { notify } from 'notiwind';
import ManualCardEntry from '@/components/wallet/modals/manual-card-entry.vue';
import Errors from '@/components/errors.vue';
import Icon from '@/components/ui/icon/icon.vue';
import SecurityInfoModal from '@/components/security/security-info-modal.vue';
import ConnectMethodChoice from '@/components/wallet/modals/connect/ConnectMethodChoice.vue';
import ConnectBankSelector from '@/components/wallet/modals/connect/ConnectBankSelector.vue';
import ConnectMxWidget from '@/components/wallet/modals/connect/ConnectMxWidget.vue';
import { useBankConnection } from '@/composables/useBankConnection.js';
import { handleError } from '@/utils/error-handler';

const props = defineProps({
    wallet: Object,
    cards: Array,
    users: Array,
    banks: Array,
    showAddCardModal: Boolean,
    setFinshedSyncAccount: Boolean,
    setFixUnresolved: Boolean,
    setHowToAddCard: String,
    step: Number,
    activeUser: Object,
    connectType: String,
    member: Object,
});

const emit = defineEmits(['close', 'addedCard', 'showAddBusinessModal']);

// --- Local state ---
const stepErrors = ref([]);
const connectStep = ref(1);
const accountUserForCard = ref('');
const showUserDropdown = ref(false);
const userDropdownStyles = ref({});
const howToAddCard = ref('');
const institutionCode = ref('');
const institutionName = ref('');
const institution = ref('');
const connectedCard = ref('');
const progressPercent = ref(10);
const activeBank = ref(null);
const bankSearchQuery = ref('');
const showSecurityInfo = ref(false);
const cardsLocal = ref([]);
const loadingCards = ref(false);
const isSmallScreen = ref(false);
const fixUnresolved = ref(false);

// Refs for child components
const mxWidgetComponent = ref(null);
const userDropdownBtn = ref(null);

// --- Bank connection composable ---
const walletRef = computed(() => props.wallet);

const {
    loadingConnectWidget,
    completedConnect,
    finshedSyncAccount,
    showAccountSyncDelayMessage,
    showInstitutionsDropdown,
    mxWidget,
    unmountWidget,
    getWidgetUrl,
    resetState: resetBankState,
} = useBankConnection(
    walletRef,
    institutionCode,
    institutionName,
    connectStep,
    () => props.connectType,
    () => props.member,
    emit,
    notify,
    () => finishAddingCard()
);

// --- Computed ---
const selectedUserName = computed(() => {
    const u = (chooseUsers.value || []).find((u) => u.id === accountUserForCard.value);
    return u ? u.name : '';
});

const bankCards = computed(() => {
    if (institution.value === '') {
        return props.cards;
    }
    return props.cards.filter((v) => v.issuing_bank.institution_code === institution.value);
});

const filteredBanks = computed(() => {
    return props.banks.filter((bank) => bank.show_in_chooser);
});

const filteredBanksList = computed(() => {
    const base = filteredBanks.value || [];
    const q = (bankSearchQuery.value || '').toLowerCase().trim();
    if (!q) return base;
    return base.filter((bank) => (bank.name || '').toLowerCase().includes(q));
});

const chosenBank = computed(() => {
    let bank = props.banks.find((obj) => obj.institution_code === institutionCode.value);
    return bank ? bank.name : '';
});

const chooseUsers = computed(() => {
    return props.users;
});

const shouldShowConnectWidget = computed(() => {
    return !completedConnect.value && !showInstitutionsDropdown.value;
});

const isStep1Mobile = computed(() => connectStep.value === 1 && isSmallScreen.value);
const isStep2Mobile = computed(() => connectStep.value === 2 && isSmallScreen.value);

const isMobileFullscreen = computed(() => {
    return (
        isSmallScreen.value &&
        (connectStep.value === 1 ||
            connectStep.value === 2 ||
            (connectStep.value === 3 &&
                (howToAddCard.value === 'add_card_manually' ||
                    howToAddCard.value === 'connect_to_bank')))
    );
});

const mobileInnerStyle = computed(() => ({
    '-webkit-transform': 'translate3d(0, 0, 0)',
    transform: 'translate3d(0, 0, 0)',
    width: '100%',
    height: '100dvh',
    minHeight: '100svh',
    maxHeight: 'none',
}));

// --- Watchers ---
watch(() => props.step, (val) => {
    connectStep.value = val;
    switch (connectStep.value) {
        case 1:
            completedConnect.value = false;
            break;
        case 3:
            setTimeout(() => {
                connectStep.value = 3;
                progressPercent.value = 90;
            }, 200);
            break;
    }
});

watch(() => props.connectType, (val) => {
    if (val === 'memberRequest') {
        connectStep.value = 3;
        howToAddCard.value = 'connect_to_bank';
        showInstitutionsDropdown.value = false;
        showAccountSyncDelayMessage.value = false;

        nextTick(() => {
            triggerGetWidgetUrl();
        });
    }
}, { immediate: true });

watch(() => props.setFinshedSyncAccount, (val) => {
    finshedSyncAccount.value = val;
});

watch(() => props.setHowToAddCard, (val) => {
    howToAddCard.value = val;
});

watch(() => props.setFixUnresolved, (val) => {
    if (val) {
        completedConnect.value = true;
    }
    fixUnresolved.value = val;
});

watch(() => props.users, () => {
    if (props.users.length === 1) {
        accountUserForCard.value = props.users[0].id;
        localStorage.setItem('accountUserForCard', accountUserForCard.value);
    }
});

watch(() => props.activeUser, () => {
    if (props.activeUser && props.activeUser.hasOwnProperty('id')) {
        accountUserForCard.value = props.activeUser.id;
    }
});

watch(() => props.showAddCardModal, () => {
    if (props.users.length === 1) {
        accountUserForCard.value = props.users[0].id;
        localStorage.setItem('accountUserForCard', accountUserForCard.value);
    }
});

// --- Methods ---
function getWidgetContainer() {
    return (
        mxWidgetComponent.value?.connectWidgetContainer ||
        document.getElementById('connect-widget')
    );
}

function triggerGetWidgetUrl() {
    getWidgetUrl(getWidgetContainer, accountUserForCard.value, gotoStep, close, stepErrors);
}

function updateScreen() {
    try {
        const mq = window.matchMedia('(max-width: 767.98px)');
        isSmallScreen.value = !!mq.matches;
    } catch (e) {
        isSmallScreen.value = window.innerWidth < 768;
    }
}

function toggleUserDropdown() {
    showUserDropdown.value = !showUserDropdown.value;
    if (showUserDropdown.value) {
        nextTick(() => {
            calculateUserDropdownPosition();
        });
    }
}

function calculateUserDropdownPosition() {
    // Find the button via the method choice component's DOM
    const btn = document.querySelector('[data-dropdown="user"] button');
    if (!btn) return;

    const rect = btn.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const dropdownHeight = 240;
    const spaceBelow = viewportHeight - rect.bottom;

    if (spaceBelow < dropdownHeight && rect.top > spaceBelow) {
        userDropdownStyles.value = {
            bottom: `${viewportHeight - rect.top + 4}px`,
            left: `${rect.left}px`,
            width: `${rect.width}px`,
        };
    } else {
        userDropdownStyles.value = {
            top: `${rect.bottom + 4}px`,
            left: `${rect.left}px`,
            width: `${rect.width}px`,
        };
    }
}

function selectUser(user) {
    accountUserForCard.value = user.id;
    setWalletUser();
    showUserDropdown.value = false;
}

function setProgress(percent) {
    progressPercent.value = percent;
}

function gotoStep(step) {
    stepErrors.value = [];

    // Redirect step 2 to step 1 (step 2 is no longer used in new flow)
    if (step === 2) {
        step = 1;
    }

    const stepsPercent = {
        1: 10,
        2: 20,
        3: 30,
    };

    // Validation when going from step 1 to step 3 (new flow)
    if (connectStep.value === 1 && step === 3) {
        if (chooseUsers.value.length > 1 && accountUserForCard.value === '') {
            stepErrors.value.push({ message: 'Please choose a user.' });
        }
        const methodVisible = chooseUsers.value.length <= 1 || !!accountUserForCard.value;
        if (methodVisible && howToAddCard.value === '') {
            stepErrors.value.push({ message: 'Please choose a method.' });
        }
    }

    if (stepErrors.value.length === 0) {
        if (step === 3) {
            showInstitutionsDropdown.value = true;
        }

        progressPercent.value = stepsPercent[step];
        connectStep.value = step;
    }
}

function setWalletUser() {
    localStorage.setItem('accountUserForCard', accountUserForCard.value);
}

function handleSelectBank(bank) {
    if (activeBank.value) {
        activeBank.value.active = false;
    }
    bank.active = true;
    activeBank.value = bank;
    institutionCode.value = bank.institution_code;
    institutionName.value = bank.name;
}

function showBankLogin() {
    if (!activeBank.value) {
        stepErrors.value.push({
            message: 'Please select a bank to continue.',
        });
        return;
    }
    triggerGetWidgetUrl();
}

function handleBack() {
    showInstitutionsDropdown.value = false;
    gotoStep(1);
}

function handleClickOutside(event) {
    if (!showUserDropdown.value) return;
    const inTrigger = event.target.closest('[data-dropdown="user"]');
    const inMenu = event.target.closest('[data-dropdown-options="user"]');
    if (!inTrigger && !inMenu) {
        showUserDropdown.value = false;
    }
}

function finishAddingCard() {
    emit('addedCard');
    setTimeout(() => {
        resetStepData();
    }, 100);
}

function resetStepData() {
    resetBankState(getWidgetContainer);

    accountUserForCard.value = '';
    howToAddCard.value = '';
    progressPercent.value = 10;
    connectStep.value = 1;
    stepErrors.value = [];
}

function close() {
    unmountWidget();

    nextTick(() => {
        resetStepData();
        emit('close');
    });
}

function showAddBusinessModal(show) {
    emit('showAddBusinessModal', show);
}

// --- Lifecycle ---
onMounted(() => {
    document.addEventListener('click', handleClickOutside);
    updateScreen();
    window.addEventListener('resize', updateScreen);
    window.addEventListener('orientationchange', updateScreen);
});

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
    window.removeEventListener('resize', updateScreen);
    window.removeEventListener('orientationchange', updateScreen);
    unmountWidget();
});
</script>

<style lang="scss" scoped>
@reference "../../../../css/app.css";
.connect-progress {
    width: 100%;
    height: 5px;
    position: absolute;
    top: -1px;
    left: 0;
    z-index: 300;
    overflow: hidden;
    border-radius: 6px;
}
.connect-progress-bar {
    height: 5px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #ff2100;
    transition: width 0.35s linear;
}
.how-to-connect-choice {
    @apply text-center
    px-3
    py-2
    block
    border-2 border-orange
    cursor-pointer
    hover:bg-orange
    hover:text-white
    transition-colors
    duration-75;

    &.active {
        @apply bg-orange
        text-white;
    }
}
.fadeInOut-enter-active,
.fadeInOut-leave-active {
    transition: opacity 0.8s;
    opacity: 1;
}
.fadeInOut-enter,
.fadeInOut-leave-to {
    opacity: 0;
}
.fadeOut-enter-active,
.fadeOut-leave-active {
    transition: opacity 0.8s;
}
.fadeOut-enter,
.fadeOut-leave-to {
    opacity: 0;
}
#connect-widget :deep(iframe) {
    width: 100% !important;
    height: 100% !important;
    min-height: inherit;
    border: none;
}
</style>
